import { createRouter as createTanStackRouter, type RouterHistory } from '@tanstack/react-router'
import { RouterError, RouterNotFound, RouterPending } from '@/components/router-feedback.tsx'
import type { AppRouterContext } from '@/trpc/context.ts'
import { routeTree } from './routeTree.gen.ts'

export function getRouter(context: AppRouterContext, history?: RouterHistory) {
  return createTanStackRouter({
    routeTree,
    context,
    history,
    scrollRestoration: true,
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    defaultPendingComponent: RouterPending,
    defaultErrorComponent: RouterError,
    defaultNotFoundComponent: RouterNotFound
  })
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
